<template>
  <v-autocomplete
    v-bind="[fieldProps, $attrs]"
    :loading="loading"
    :items="items"
    v-model="model"
    :filter="filterItems"
    :search-input="search"
    name="bairro"
    placeholder="Bairro"
    :no-data-text="noDataText"
    :menu-props="menuProps"
    clearable
    multiple
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item }}</span>
      </v-chip>

      <span v-if="index === 1" class="text-body-2 font-weight-regular">
        (+{{ model.length - 1 }})
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mixin } from "./mixin";

const _config = {
  mod: "districts",
};

const _data = {
  loading: false,
  model: null,
  search: null,
  items: [],
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    menuProps() {
      const height = window.innerHeight / 2 - 24;

      return {
        maxHeight: height,
        closeOnContentClick: true,
      };
    },
    noDataText() {
      if (["/"].includes(this.$route.path) || this.$route.query.cidade)
        return "Não há dados disponíveis";

      return "Selecione uma cidade";
    },
    query() {
      return this.$route.query;
    },
    business() {
      switch (this.$route.path) {
        case "/imoveis":
          return "Venda";
        case "/locacao":
          return "Aluguel";
        default:
          return null;
      }
    },
    category() {
      const category = this.query.tipo;

      if (category) return category;

      switch (this.$route.path) {
        case "/terrenos":
          return "Terreno,Terreno Comercial";
        case "/rural":
          return "Área,Chácara,Fazenda,Sítio";
        default:
          return "";
      }
    },
  },
  methods: {
    filterItems(item, queryText) {
      const filter = queryText
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

      return (
        item
          .normalize("NFD")
          .toLowerCase()
          .replace(/[\u0300-\u036f]/g, "")
          .indexOf(filter) !== -1
      );
    },
    getList() {
      this.loading = true;
      this.items = [];

      const params = {};

      if (!["/"].includes(this.$route.path) && this.$route.query.cidade)
        params.city = this.$route.query.cidade;

      if (this.business) params.business = this.business;
      if (this.category) params.category = this.category;

      this.$rest(_config.mod)
        .get({ params })
        .then((data) => {
          this.items = data;
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route(v) {
      this.model = v.query.bairro
        ? v.query.bairro.split(",").map((v) => v)
        : null;

      if (["/"].includes(v.path) || v.query.cidade) this.getList();
      else this.items = [];
    },
  },
  mounted() {
    if (["/"].includes(this.$route.path) || this.$route.query.cidade)
      this.getList();

    if (this.$route.query.bairro)
      this.model = this.$route.query.bairro.split(",").map((v) => v);
  },
  mixins: [mixin],
};
</script>
